import { ApiClient } from '@k2/common/backend/api-client';

export class VendorEndpoint {
  constructor(private api: ApiClient) {

  }

  initiateVendor = (assignmentServiceInstanceId: number, vendorId: number, collectionId: string, smdInstanceId: string, data) => {
    return this.api.post(
      `/assignment-service-instance/${assignmentServiceInstanceId}/vendor/${vendorId}/collection/${collectionId}/smd-instance-id/${smdInstanceId}/initiate`,
      data
    );
  };

  initiateVendorOffPlatform = (assignmentServiceInstanceId: number, vendorId: number, collectionId: string, smdInstanceId: string) => {
    return this.api.post(
      `/assignment-service-instance/${assignmentServiceInstanceId}/vendor/${vendorId}/collection/${collectionId}/smd-instance-id/${smdInstanceId}/initiate-off-platform`,
      {}
    );
  };
}
